import { providePrimeNG } from 'primeng/config';
import { PinnaklPrimePreset } from './pinnakl.prime.preset';

export function providePinnaklPrimeNg() {
  return providePrimeNG({
    theme: {
      preset: PinnaklPrimePreset,
      options: {
        darkModeSelector: false,
        cssLayer: {
          name: 'primeng',
          order: 'theme, base, primeng, components, utilities',
        },
      },
    },
  });
}
